import { useEffect, useRef, useState } from "react";

import Guest1Img from "../../assets/images/conversations/ep-60-thirumalai-nc-guest.webp";
import Guest2Img from "../../assets/images/conversations/ep-60-ravin-mirchandani-guest.webp";
import ThumbImg  from "../../assets/images/conversations/060.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: tn-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .tn-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }

  /* ── INNER ── */
  .tn-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ══════════════════════════════════════
     SECTION 1 — HERO (2-col)
  ══════════════════════════════════════ */
  .tn-hero {
    padding-top: 60px;
    padding-bottom: 60px;
  }
  .tn-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }

  /* LEFT */
  .tn-hero__left {
    display: flex;
    flex-direction: column;
    gap: 44px;
  }
  .tn-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .tn-hero__title.tn-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .tn-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .tn-hero__spotify.tn-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .tn-hero__spotify iframe {
    display: block;
    width: 100%;
    height: 152px;
    border: none;
    border-radius: 12px;
  }

  /* RIGHT */
  .tn-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .tn-hero__right.tn-visible {
    opacity: 1;
    transform: translateY(0);
  }

  /* thumbnail wrapper */
  .tn-yt-thumb {
    position: relative;
    width: 100%;
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
    display: block;
    background: #000;
  }
  .tn-yt-thumb img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 12px;
    transition: opacity 0.3s ease;
  }
  .tn-yt-thumb:hover img {
    opacity: 0.85;
  }

  /* play button */
  .tn-yt-thumb__play {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
   background: none;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.25s ease;
    pointer-events: none;
  }
  .tn-yt-thumb__play img {
    width: 40px;
    height: 44px;
    margin-left: 4px;
    fill: #ffffff;
  }

  /* iframe */
  .tn-yt-iframe-wrap {
    position: relative;
    width: 100%;
    padding-bottom: 56.25%;
    height: 0;
    border-radius: 12px;
    overflow: hidden;
  }
  .tn-yt-iframe-wrap iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
  }

  /* ══════════════════════════════════════
     SECTION 2 — BODY
  ══════════════════════════════════════ */
  .tn-body {
    padding-bottom: 100px;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .tn-body.tn-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .tn-body__para {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #E2E2E2;
    line-height: 160%;
    margin-bottom: 14px;
  }
  .tn-body__para:last-child { margin-bottom: 0; }

  /* ══════════════════════════════════════
     SECTION 3 — OUR GUEST (2 guests)
  ══════════════════════════════════════ */
  .tn-guest {
    padding-bottom: 100px;
    text-align: center;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .tn-guest.tn-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .tn-guest__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 50px;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 60px;
  }

  /* 2-col guest grid */
  .tn-guest__grid {
    display: flex;
    justify-content: center;
    gap: 60px;
  }
  .tn-guest__card {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .tn-guest__photo-bg {
    width: 445px;
    height: 500px;
    background: #743FAC;
    border-radius: 12px;
    overflow: hidden;
  }
  .tn-guest__photo-bg img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top center;
    display: block;
  }
  .tn-guest__name {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .tn-inner { padding-left: 32px; padding-right: 32px; }
    .tn-hero { padding-top: 32px; padding-bottom: 48px; }
    .tn-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .tn-hero__title { font-size: 24px; }
    .tn-hero__left { gap: 16px; }
    .tn-guest__title { font-size: 24px; margin-bottom: 24px; }
    .tn-guest__grid { gap: 24px; }
    .tn-guest__photo-bg { width: 100%; height: 300px; }
    .tn-guest__name { font-size: 24px; margin-top: 18px; }
    .tn-body__para { font-size: 14px; margin-bottom: 12px; }
    .tn-body { padding-bottom: 48px; }
    .tn-guest { padding-bottom: 48px; }
    .tn-yt-thumb__play img{ width: 30px; height: 32px;}
    
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .tn-inner { padding-left: 16px; padding-right: 16px; }
    .tn-hero { padding-top: 51px; padding-bottom: 30px; }
    .tn-hero__grid { grid-template-columns: 1fr; gap: 40px; }
    .tn-hero__left { gap: 30px; }
    .tn-hero__title { font-size: 30px; }
    .tn-body__para { font-size: 16px; margin-bottom: 10px; }
    .tn-guest__title { font-size: 30px; margin-bottom: 20px; }
    .tn-guest__grid { flex-direction: column; gap: 30px; }
    .tn-guest__photo-bg { width: 100%; height: 386px; }
    .tn-guest__name { font-size: 24px; text-align: left; }
    .tn-body { padding-bottom: 30px; }
    .tn-guest { padding-bottom: 30px; }
    .tn-guest__card { align-items: start;}
    .tn-yt-thumb__play img{ width: 30px; height: 32px;}


  }
`;

/* ─────────────────────────────────────────────
   FADE-UP HOOK
───────────────────────────────────────────── */
function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("tn-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

/* ─────────────────────────────────────────────
   YOUTUBE EMBED
───────────────────────────────────────────── */
const YT_VIDEO_ID = "H1km6H8hYqQ";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);

  if (playing) {
    return (
      <div className="tn-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 60 Thirumalai NC"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <div className="tn-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 60 Thirumalai NC thumbnail" />
      <div className="tn-yt-thumb__play">
        
        <img src={PlayIcon} />
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────
   SECTIONS
───────────────────────────────────────────── */
function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);

  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="tn-hero">
      <div className="tn-inner">
        <div className="tn-hero__grid">

          {/* LEFT */}
          <div className="tn-hero__left">
            <h1 ref={titleRef} className="tn-hero__title">
              EP 60 | Bangalore's pollution- a victim of its own economic success. Can EVs change that? Thirumalai NC
            </h1>
            <div ref={spotifyRef} className="tn-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/6ILyWYBzMbBWJhuk1zRKhy?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 60 Spotify Player"
              />
            </div>
          </div>

          {/* RIGHT */}
          <div ref={rightRef} className="tn-hero__right">
            <YouTubeEmbed />
          </div>

        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);

  return (
    <section ref={ref} className="tn-body">
      <div className="tn-inner">
        <p className="tn-body__para">
          Bangalore's pollution- a victim of its own economic success. Can EVs change that? | Thirumalai NC, Sector Head – Strategic Studies at CSTEP
        </p>
        <p className="tn-body__para">
          In this episode of the Energizing India Podcast, we head to India's tech capital — Bangalore — a city at the heart of innovation, but also at the edge of an infrastructure overload.
        </p>
        <p className="tn-body__para">
          With startups like Ola, Ather, and Exponent leading India's clean mobility revolution, Bangalore is setting the stage for what's to come in 20 more cities. However, rapid economic growth comes with a paradox: 80% of households now own personal vehicles, and the city's air quality is plummeting.
        </p>
        <p className="tn-body__para">
          We're joined by Thirumalai NC, Sector Head at CSTEP, one of India's leading think tanks in science, tech, and policy. He helps us understand the unique urban challenge Bangalore faces: Can a traffic-choked city leap into an electric future — and where will all that charging power come from?
        </p>
        <p className="tn-body__para">
          This is a story of hope, policy innovation, and the race to plug into a cleaner tomorrow.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);

  return (
    <section ref={ref} className="tn-guest">
      <div className="tn-inner">
        <h2 className="tn-guest__title">Our Guest</h2>
        <div className="tn-guest__grid">

          <div className="tn-guest__card">
            <div className="tn-guest__photo-bg">
              <img src={Guest1Img} alt="Thirumalai NC" />
            </div>
            <p className="tn-guest__name">Thirumalai NC</p>
          </div>

          <div className="tn-guest__card">
            <div className="tn-guest__photo-bg">
              <img src={Guest2Img} alt="Ravin Mirchandani" />
            </div>
            <p className="tn-guest__name">Ravin MIRCHANDANI</p>
          </div>

        </div>
      </div>
    </section>
  );
}

/* ─────────────────────────────────────────────
   ROOT
───────────────────────────────────────────── */
export default function Ep60ThirumalaiNC() {
  return (
    <>
      <style>{CSS}</style>
      <div className="tn-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}